import { render } from "./PbLogin.vue?vue&type=template&id=bdb92c08&scoped=true"
import script from "./PbLogin.vue?vue&type=script&lang=js"
export * from "./PbLogin.vue?vue&type=script&lang=js"

import "./PbLogin.vue?vue&type=style&index=0&id=bdb92c08&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/project-booster--collaborator/project-booster--collaborator/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdb92c08"]])

export default __exports__